import OddsServices from '../../../services/OddsServices';
import LiveCenterServices from '../../../services/LiveCenterServices';
import CommonUtil from '../../../common/CommonUtil';
import _ from 'lodash';
import $ from 'jquery';
import { getOddsFormatByIdHR } from '../../../common/Foundation';
import MemberService from '../../../services/MemberService';
import AccountAction from '../../../actions/AccountAction';

export default class OddsPageAction {

  /**
   * get normal events
   * @param {*} params 
   */
  static async getCompactEvents (params) {
    const dataEvents = await OddsServices.getCompactEvents(params).then(res => {
      return res.data;
    }).catch(err => {

    });
    return dataEvents;
  }

  /**
   * get normal events
   * @param {*} params 
   */
  static async getCompactFavouriteEvents(params) {
    const dataEvents = await OddsServices.getCompactFavouriteEvents(params).then(res => {
      return res.data;
    }).catch(err => {

    });
    return dataEvents;
  }

  /**
   * get more bets events
   * @param {*} params 
   */
  static async getMoreBetEvents (params) {
    const dataEvents = await OddsServices.loadMoreBetsEvents(params).then(res => {
      return res.data;
    }).catch(err => {

    });
    return dataEvents;
  }

  /**
   * get more bets events
   * @param {*} params 
   */
  static async getOutrightEvents(sportId, params) {
    const dataEvents = await OddsServices.getOutrightEvents(sportId, params).then(res => {
      return res.data;
    }).catch(err => {
      return [];
    });
    return dataEvents;
  }

  /**
   * get more bets events
   * @param {*} params 
   */
  static async getTeaserEvents(params) {
    const dataEvents = await OddsServices.getTeaserEvents(params).then(res => {
      return res.data;
    }).catch(err => {
      return {};
    });
    return dataEvents;
  }

  /**
   * get all live events
   * @param {*} params 
   */
  static async getAllLiveCenterEvents(liveCenterSeverPath, params) {
    const allEvents = await LiveCenterServices.getAllLiveCenterEvents(liveCenterSeverPath, params).then(res => {
      return res.data;
    }).catch(err => {
      return {};
    });
    return allEvents;
  }
  static async getAllLiveTVEvents(liveCenterSeverPath, params) {
    const allEvents = await LiveCenterServices.getAllLiveTVEvents(liveCenterSeverPath, params).then(res => {
      return res.data;
    }).catch(err => {
      return {};
    });
    return allEvents;
  }

  /** 
   * Get the search suggestions
   * @param {*} params - {sportId, searchText}
   */
  static async getSearchSuggestions(params) {
    return await OddsServices.getSearchSuggestions(params).then(res => {
      return res.data;
    }).catch(err => {
      return [];
    });
  }

  static async getSearchNormalEvents(params) {
    const dataEvents = await OddsServices.getSearchNormalEvents(params).then(res => {
      return res.data;
    }).catch(err => {
      return [];
    });

    return dataEvents;
  }

  static async getSearchOutrightEvents(sportId, params) {
    const dataEvents = await OddsServices.getSearchOutrightEvents(sportId, params).then(res => {
      return res.data;
    }).catch(err => {
      return [];
    });

    return dataEvents;
  }
  

  static async filterValidFavourite(leagueIds, eventIds) {
    const leagueIdsParams = leagueIds.map(league => league.id);
    const eventIdsParams = eventIds.map(event => event.id);
    return await MemberService.getCompactFavouriteSports(eventIdsParams.join(","), leagueIdsParams.join(",")).then(res => {
      const leagues = _.get(res.data, 'leagues', []);
      const events = _.get(res.data, 'events', []);
      let eventNotEndYet = [];
      let leagueNotEndYet = [];
      events.forEach(value => {
        eventNotEndYet.push(value.id);
      });
      leagues.forEach(value => {
        leagueNotEndYet.push(value.id);
      });
      const validFavourite = { validEventId: eventNotEndYet, validLeagueId: leagueNotEndYet };
      return validFavourite;
    }).catch(e => {
      console.log(e);
    });
  }

  static async checkValidFavourite(isAuth, leagueIds, eventIds) {
    let isMaxValue = true;
    let newLeaugeIds = [];
    let newEventIds = [];
    if (isAuth) {
      //Call service to get event or league still valid
      const validFavourite = await this.filterValidFavourite(leagueIds, eventIds);
      if (validFavourite) {
        const leagueIdsValidArr = validFavourite.validLeagueId;
        const eventIdsValidArr = validFavourite.validEventId;
        isMaxValue = this.validNumberFavorite(eventIdsValidArr, leagueIdsValidArr);
        if (!isMaxValue) {
          // replace all valid leagueId or eventIds in local storeage  
          newLeaugeIds = leagueIds.filter(item => leagueIdsValidArr.find(id => id === item.id));
          newEventIds = eventIds.filter(item => eventIdsValidArr.find(id => id === item.id));
        }
      }
    }
    return { isMaxValue: isMaxValue, leagueIds: newLeaugeIds, eventIds: newEventIds }
  }

  static async getfavouriteDataOnClick(favouriteDataOps, event, isSingleEventPerLeaguePage = false, isAuth) {
    let leagueIds = _.get(favouriteDataOps, 'leagueIds', []);
    let eventIds = _.get(favouriteDataOps, 'eventIds', []);
    const $currentTarget = $(event.currentTarget);
    $currentTarget.toggleClass('fav-on');
    const isAdd = $currentTarget.is('.fav-on');
    let parentEle = $currentTarget.parent();
    let isMaxValue = false;
    if (parentEle.is('.league')) {
      const lstEle = parentEle.next().find('a.bookmark');
      const leagueId = $(event.target).data('league-id');
      const leagueIdsArr = CommonUtil.convertToFavouriteArray(leagueId);
      if (isAdd) {
        const leagueBeforeAdded = leagueIds.addAll(leagueIdsArr);
        if (this.validNumberFavorite(leagueBeforeAdded, eventIds)) {
          $(lstEle).toggleClass('fav-on', isAdd);
          leagueIds = leagueIds.addAll(leagueIdsArr);
          this.toggleFavAllEventsOfLeague(leagueId, true);
        } else {
          const validReponse = await this.checkValidFavourite(isAuth, leagueIds, eventIds);
          isMaxValue = validReponse.isMaxValue;
          leagueIds = validReponse.leagueIds.length < 0 ? validReponse.leagueIds : leagueIds;
          if (isMaxValue) {
            $currentTarget.toggleClass('fav-on', false);
            this.openMaxAddedFavMessage(parentEle);
          }
          else {
            this.toggleFavAllEventsOfLeague(leagueId, true);
          }
        }
      } else {
        leagueIds = leagueIds.filter((item) => item.id && item.id !== leagueId);
        const removeSelectedEventId = this.getAllEventIdByLeagueId(leagueId);
        eventIds = eventIds.filter(eventId => !removeSelectedEventId.includes((eventId.id && eventId.id.toString().includes('_')) ? eventId.eventId : eventId.id));
        this.toggleFavAllEventsOfLeague(leagueId, false);
      }
    } else {
      const $currentEventTable = $currentTarget.closest("table.events")
      parentEle = $currentEventTable.parent();
      const prevElement = parentEle.prev();
      const allFavLength = parentEle.find("a.bookmark").length
      let isRemoveInLeague = false
      const prevBookmark = prevElement.find("a.bookmark");
      const isLeagueAdded = prevBookmark.is('.fav-on');

      if (parentEle.find("a.bookmark.fav-on").length === allFavLength && !isLeagueAdded && !isSingleEventPerLeaguePage) {
        prevBookmark.toggleClass("fav-on", true)
      } else if (allFavLength !== 1 && isLeagueAdded) {
        isRemoveInLeague = true;
      }

      if (parentEle.find("a.bookmark:not(.fav-on)").length === allFavLength
        && isLeagueAdded && allFavLength !== 1) {
        prevBookmark.toggleClass("fav-on", false)
        isRemoveInLeague = false;
      }

      if (allFavLength === 1 && isLeagueAdded) {
        isRemoveInLeague = true;
      }
      if (prevElement.is('.league')) {
        const isAddLeague = prevElement.find("a.bookmark").is('.fav-on');
        const favLeague = prevElement.find("i.fav");
        const leagueId = $(favLeague).data('league-id');
        const leagueIdsArr = CommonUtil.convertToFavouriteArray(leagueId);
        if (isAddLeague && isAdd) {
          const leagueBeforeAdded = leagueIds.addAll(leagueIdsArr);
          if (this.validNumberFavorite(leagueBeforeAdded, eventIds)) {
            leagueIds = leagueIds.addAll(leagueIdsArr);
            this.toggleFavAllEventsOfLeague(leagueId, true);
          } else {
            prevElement.find("a.bookmark").toggleClass("fav-on", false);
            $currentTarget.toggleClass('fav-on', false);
            this.openMaxAddedFavMessage($currentEventTable);
            isMaxValue= true;
          }
        } else {
          if (!isRemoveInLeague) {
            const id = $(favLeague).data('league-id');
            leagueIds = leagueIds.filter((item) => item.id && item.id !== id);
          }
          const eventIdsArr = CommonUtil.convertToFavouriteArray($currentTarget.data('eventId'));
          if (isAdd) {
            const eventsBeforeAdded = eventIds.addAll(eventIdsArr);
            if (this.validNumberFavorite(leagueIds, eventsBeforeAdded)) {
              eventIds = eventIds.addAll(eventIdsArr)
            } else {
              const validReponse = this.checkValidFavourite(isAuth, leagueIds, eventIds);
              isMaxValue = validReponse.isMaxValue;
              eventIds = validReponse.eventIds.length < 0 ? validReponse.eventIds : eventIds;
              if (isMaxValue) {
                $currentTarget.toggleClass('fav-on', false);
                this.openMaxAddedFavMessage(parentEle);
              }
            }
          } else {
            if (isRemoveInLeague) {
              $currentTarget.toggleClass('fav-on', !isAdd);
            }
            const id = $currentTarget.data('eventId')
            eventIds = eventIds.filter((item) => item.id !== id);
          }
        }
      }
    }
    const updatedEvents = eventIds.reduce((initValue, event) => {
      if (event) {
        const itemId = event.id;
        if (itemId && itemId.toString().includes('_')) {
          const parentEventId = parseInt(itemId.split('_')[0] || 0, 10);
          const eventId = parseInt(itemId.split('_')[1] || 0, 10);
          const element = {
            ...event,
            parentEventId: parentEventId || eventId,
            eventId: eventId,
            period: parseInt(itemId.split('_')[2] || null, 10)
          }
          return [...initValue, element];
        } else {
          return [...initValue, event];
        }
      }
    }, []);
    const favouriteData = {
      leagueIds: _.uniqBy(leagueIds, "id"),
      eventIds: _.uniqBy(updatedEvents, "id"),
      isMaxValue: isMaxValue
    }
    return favouriteData;
  }

  static async getSportsbookFavoriteByUserId() {
    return await MemberService.getSportsbookFavoriteByUserId().then(res => {
      return res.data;
    }).catch(e => {
      return {};
    })
  }

  static async updateSportsbookFavoriteByUserId(favouriteData) {
    const eventIds = favouriteData && favouriteData.eventIds ? favouriteData.eventIds.filter(event => event) : [];
    const leagueIds = favouriteData && favouriteData.leagueIds ? favouriteData.leagueIds.filter(league => league) : [];
    const sbFavourite = { eventIds, leagueIds };
    const res = await MemberService.updateSportsbookFavoriteByUserId(sbFavourite);
    return res && res.data ? res.data : false; 
  }

  static toggleFavAllEventsOfLeague(leagueId, isToggleClass = false) {
    const currEle = $(document).find(`i.fav[data-league-id='${leagueId}'`);
    const leagueBookmark = currEle.parent();
    leagueBookmark.toggleClass('fav-on', isToggleClass);
    const parentEle = leagueBookmark.parent();
    parentEle.next().find('a.bookmark').toggleClass('fav-on', isToggleClass);
  }
  
  static getAllEventIdByLeagueId(leagueId) {
    const currEle = $(document).find(`i.fav[data-league-id='${leagueId}'`);
    const leagueBookmark = currEle.parent();
    const parentEle = leagueBookmark.parent();
    const tableEventsId = parentEle.next().find('table').map(function() {
      return $(this).attr('id');
    }).get();
    const eventsId = tableEventsId.reduce((listEv, event) => {
      const eventId = event.replace("e","");
      listEv.push(parseInt(eventId));
      return listEv;
    }, []);
    return eventsId || [];
  }

  static validNumberFavorite(leagueIds = [], eventIds = []) {
    return (leagueIds.length + eventIds.length) <= 20;
  }

  static openMaxAddedFavMessage($currentTarget) {
    const $favoriteTooltip = $currentTarget.find('.fav-custom-tooltip');
    $favoriteTooltip.toggleClass("tooltip-on", !$favoriteTooltip.is('.tooltip-on'))
  }

  static closeMaxAddedFavMessage($currentTarget) {
    $currentTarget.find('.fav-custom-tooltip').toggleClass("tooltip-on", false);
  }

  static removeRBAuthLocalStorage() {
    localStorage.removeItem('token-user');
    localStorage.removeItem('secretKey');
  }

  static getSupportedOddsFormat(currency, userMode, oddsFormatSetting) {
    const supportedOddsFormats = CommonUtil.getOddsFormatKeys(currency, userMode, oddsFormatSetting);
    return Object.values(supportedOddsFormats).map(value => {
      return getOddsFormatByIdHR(value)
    }).join(',') || ''
  }

   /**
   * get matchup navigation
   * @param {*} params 
   */
    static async getMatchupNavigation (params) {
      const dataEvents = await OddsServices.getMatchupNavigation(params).then(res => {
        return res.data;
      }).catch(err => {
  
      });
      return dataEvents;
    }
  
  static doShowMoreTennis = (eventId) => {
    $(`.pe${eventId}.isNotMatch`).removeClass("hide");
    $(`.show-less.pe${eventId}`).removeClass("hide");
    $(`.show-more.pe${eventId}`).addClass("hide");
  };

  static openTennisMoreMarketTooltip = (firstLoad, isAuth) => {
    if ((isAuth && CommonUtil.getUserData().moreBetTooltipHidden) || (!isAuth && localStorage.getItem("moreBetTooltipHidden"))) return;

    // If it's the first load, set a timeout to display the tooltip after 500 milliseconds.
    if (firstLoad) {
      setTimeout(() => {
        $('.more-market-custom-tooltip').first().toggleClass("tooltip-on", true);
      }, 500);

      return
    }
    $('.more-market-custom-tooltip').first().toggleClass("tooltip-on", true);
  };

  static closeTennisMoreMarketTooltip = (isAuth) => {

    if (isAuth && !CommonUtil.getUserData().moreBetTooltipHidden) {
      AccountAction.closeMorebetTooltip()
      CommonUtil.saveUserData('moreBetTooltipHidden', true)
    }

    if(!isAuth && localStorage.getItem("moreBetTooltipHidden")) return

    $('.more-market-custom-tooltip').first().toggleClass("tooltip-on", false)
    localStorage.setItem("moreBetTooltipHidden", true)
  };

  static toggleTennisMoreBet = (event, expandedEvents, setExpandedEvents) => {
    const eventId = $(event.currentTarget).data().eventParentId;
    const isExpanded = expandedEvents.includes(eventId);

    // If the eventId is in the expandedEvents array, remove it.
    // Otherwise, add it to the expandedEvents array.
    setExpandedEvents(isExpanded ? expandedEvents.filter(ev => ev !== eventId) : [...expandedEvents, eventId])

    // This will show or hide the element based on the value of isExpanded.
    $(`.pe${eventId}.isNotMatch`).toggleClass("hide", isExpanded);
    // This will show or hide the element based on the value of isExpanded.
    $(`.show-less.pe${eventId}`).toggleClass("hide", isExpanded);
    $(`.show-more.pe${eventId}`).toggleClass("hide", !isExpanded);
};

  static checkShowMoreTennisBet = (expandedEvents) => {
    expandedEvents.forEach(OddsPageAction.doShowMoreTennis);
  };

  static removeUnUseShowMoreTennisBtn = () => {
    const moreBetBtns = $('.tennis-more-events-btn');

    if (!moreBetBtns.length) return;

    moreBetBtns.each((idx, moreBetBtn) => {
      const eventParentId = moreBetBtn.dataset.eventParentId;
      const periods = $(`.events.tennis.pe${eventParentId}`);

      // Check if there are less than 2 periods with markets
      if (periods.filter((i, p) => p.children[0].children.length >= 2).length < 2) {
        $(`.tennis-more-events.pe${eventParentId}`).toggleClass("hide", true);
      }
    });
  };

}



// WEBPACK FOOTER //
// ./src/app/components/CompactView/OddsPageComponent/OddsPageActions.js